import React, { useEffect, useState } from "react";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  deleteInvoiceReceipts,
  getAllInvoiceReceiptsSync,
  getInvoiceReceiptsList,
  viewInvoiceReceipts,
} from "../../services/MoloniServices";
import moment from "moment/moment";
import { tConstStatic } from "../../utils/constantsTranslator";

const MoloniInvoiceReceipts = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [invoiceReceiptsList, setInvoiceReceiptsList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [modalView, setModalView] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    id: "",
    title: "",
    moloni_id: "",
  });
  const [invoiceViewList, setInvoiceViewList] = useState("");


  const handleViewInvoiceClose = () => {
    setModalView(false);
  };

  useEffect(() => {
    if (invoiceData?.id) {
      let data = { id: invoiceData?.id };
      viewInvoiceReceipts(data)
        .then((response) => {
          setInvoiceViewList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [invoiceData]);

  const onEditDetails = (e, item) => {
    setModalView(true);
    setInvoiceData({
      id: item?.id,
      title: item?.title,
      moloni_id: item?.moloni_id,
    });
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetctInvoiceReceiptsList = () => {
    let data = { ...params };
    getInvoiceReceiptsList(data)
      .then((response) => {
        setInvoiceReceiptsList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetctInvoiceReceiptsList(data);
    },
    [params]
  );

  const handleInvoiceReceiptsSync = () => {
    setIsProductLoading(true);
    let data = { company_id: "269134" };
    getAllInvoiceReceiptsSync(data)
      .then((response) => {
        toast.success(response.data.message);
        let data = { ...params };
        getInvoiceReceiptsList(data)
          .then((response) => {
            setInvoiceReceiptsList(response.data.data);
            setTotalRecords(response.data.total);
            setIsProductLoading(false);
          })
          .catch((err) => {
            setIsProductLoading(false);
            toast.error(Utils.getErrorMessage(err));
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsProductLoading(false);
      });
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.document_id);
    setDelModal(true);
  };

  const onDestroyInvoiceReceipts = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { document_id: delType, company_id: "269134" };
    deleteInvoiceReceipts(data)
      .then((response) => {
        let data = { ...params };

        fetctInvoiceReceiptsList(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const getStatusText = (status) => {
    switch (status) {
      case 0:
        return tConstStatic("Draft");
      case 1:
        return tConstStatic("Closed/Finalized");

      default:
        return "-";
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("invoiceReceipts")}</h1>
              </div>

             
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-title m-0 float-right d-flex ">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={() => navigate("/add-invoice-receipts")}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>

                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleInvoiceReceiptsSync}
                          disabled={isProductLoading}
                        >
                          {isProductLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("No")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("entity_name")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("date")}
                                  </th>{" "}
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("status")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("netValue")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {invoiceReceiptsList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item?.number}</td>
                                        <td>{item.entity_name}</td>

                                        <td>{item.date}</td>
                                        <td>{getStatusText(item.status)}</td>

                                        <td>{item.net_value}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive"
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              {item?.number === -1 && (
                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    navigate(
                                                      `/update-invoice-receipts/${item.id}`
                                                    )
                                                  }
                                                >
                                                  <div className="edit-btn">
                                                    <i className="bi bi-pencil"></i>
                                                  </div>
                                                  <span>{t("edit")}</span>
                                                </Dropdown.Item>
                                              )}

                                              {item?.number === -1 && (
                                                <Dropdown.Item
                                                  href="#/action-2"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    onDeleteModalOpen(e, item)
                                                  }
                                                >
                                                  <div className="trash-btn">
                                                    <a className="delete-btn">
                                                      <i className="bi bi-trash3"></i>
                                                    </a>
                                                  </div>
                                                  <span>{t("delete")}</span>
                                                </Dropdown.Item>
                                              )}
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onEditDetails(e, item)
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-eye-fill"></i>{" "}
                                                </div>
                                                <span>{t("view")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {invoiceReceiptsList &&
                                invoiceReceiptsList?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className={`text-center`}>
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive1  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("No")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("entity_name")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("date")}
                                  </th>{" "}
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("status")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("netValue")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {invoiceReceiptsList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                      <td>{item.number}</td>

                                        <td>{item.entity_name}</td>

                                        <td>{item.date}</td>
                                        <td>{getStatusText(item.status)}</td>

                                        <td>{item.net_value}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1"
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              {item?.number === -1 && (
                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    navigate(
                                                      `/update-internal-documents/${item.id}`
                                                    )
                                                  }
                                                >
                                                  <div className="edit-btn">
                                                    <i className="bi bi-pencil"></i>
                                                  </div>
                                                  <span>{t("edit")}</span>
                                                </Dropdown.Item>
                                              )}

                                              {item?.number === -1 && (
                                                <Dropdown.Item
                                                  href="#/action-2"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    onDeleteModalOpen(e, item)
                                                  }
                                                >
                                                  <div className="trash-btn">
                                                    <a className="delete-btn">
                                                      <i className="bi bi-trash3"></i>
                                                    </a>
                                                  </div>
                                                  <span>{t("delete")}</span>
                                                </Dropdown.Item>
                                              )}

                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onEditDetails(e, item)
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-eye-fill"></i>{" "}
                                                </div>
                                                <span>{t("view")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {invoiceReceiptsList &&
                                invoiceReceiptsList?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className={`text-center`}>
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer card-footer-part clearfix card-footer"
            style={{marginTop:"-26px"}}
            
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("deleteinvoiceReceipts")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{t("delete_invoice_receipts")}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyInvoiceReceipts}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalView} size="xl">
        <ModalHeader>{t("invoiceReceiptDetails")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div
                    className="row"
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("customerNo")}:</strong>{" "}
                        {invoiceViewList?.entity_number || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("customerName")}:</strong>{" "}
                        {invoiceViewList?.entity_name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("status")}:</strong>{" "}
                        {getStatusText(invoiceViewList?.status || "-")}
                      </h6>
                    </div>
                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("customerVat")}:</strong>{" "}
                        {invoiceViewList?.entity_vat || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("customerAddress")}:</strong>{" "}
                        {invoiceViewList?.entity_address || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("grossValue")}:</strong>{" "}
                        {invoiceViewList?.gross_value || 0}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("taxValue")}:</strong>{" "}
                        {invoiceViewList?.taxes_value || 0}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("deductionValue")}:</strong>{" "}
                        {invoiceViewList?.deduction_value || 0}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("netValue")}:</strong>{" "}
                        {invoiceViewList?.net_value || 0}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("documentSet")}:</strong>{" "}
                        {invoiceViewList?.document_set_name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("maturityDates")}:</strong>{" "}
                        {invoiceViewList?.maturity_date_name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("notes")}:</strong>{" "}
                        {invoiceViewList?.notes || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("yourReference")}:</strong>{" "}
                        {invoiceViewList?.your_reference || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("ourReference")}:</strong>{" "}
                        {invoiceViewList?.our_reference || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_datetime")}:</strong>{" "}
                        {invoiceViewList?.delivery_datetime
                          ? moment(invoiceViewList.delivery_datetime).format(
                              "DD/MM/YYYY HH:mm"
                            )
                          : "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_departure_address")}:</strong>{" "}
                        {invoiceViewList?.delivery_departure_address || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_departure_city")}:</strong>{" "}
                        {invoiceViewList?.delivery_departure_city || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_departure_zip_code")}:</strong>{" "}
                        {invoiceViewList?.delivery_departure_zip_code || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_destination_address")}:</strong>{" "}
                        {invoiceViewList?.delivery_destination_address || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_destination_city")}:</strong>{" "}
                        {invoiceViewList?.delivery_destination_city || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_destination_country")}:</strong>{" "}
                        {invoiceViewList?.delivery_destination_country_details
                          ?.name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_destination_zip_code")}:</strong>{" "}
                        {invoiceViewList?.delivery_destination_zip_code || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("delivery_method_name")}:</strong>{" "}
                        {invoiceViewList?.delivery_method_name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("related_documents_notes")}:</strong>{" "}
                        {invoiceViewList?.related_documents_notes || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("salesman_commission")}:</strong>{" "}
                        {invoiceViewList?.salesman_commission || "-"}
                      </h6>
                    </div>

                    <div className="col-md-6">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        <strong>{t("special_discount")}:</strong>{" "}
                        {invoiceViewList?.special_discount || "-"}
                      </h6>
                    </div>
                  </div>
                  {invoiceViewList?.products?.length > 0 && (
                    <div className="row mt-4">
                      <h5>{t("product")}</h5>

                      <div className="col-lg-12">
                        <div className="vehicleThBg table-responsive table-responsive-sm">
                          <Table
                            className="rounded-table"
                            striped
                            bordered
                            hover
                          >
                            <thead>
                              <tr>
                                <th>{t("name")}</th>
                                <th>{t("price")} €</th>
                                <th>Qty</th>
                                <th>{t("exemption_reason")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {invoiceViewList?.products?.length > 0 ? (
                                invoiceViewList?.products?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item.name}</td>
                                      <td>{Number(item.price).toFixed(2)} €</td>
                                      <td>{item.qty}</td>
                                      <td>{item.exemption_reason}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="100%" className="text-center">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  )}

                  {invoiceViewList?.products?.length > 0 && (
                    <div className="row mt-4">
                      <h5>{t("taxes")}</h5>

                      <div className="col-lg-12">
                        <div className="vehicleThBg table-responsive table-responsive-sm">
                          <Table
                            className="rounded-table"
                            striped
                            bordered
                            hover
                          >
                            <thead>
                              <tr>
                                <th>{t("value")}</th>
                                <th>{t("order")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {invoiceViewList?.products?.length > 0 ? (
                                invoiceViewList.products.map((item, pIndex) =>
                                  item?.taxes?.map((prop, index) => (
                                    <tr key={`${pIndex}-${index}`}>
                                      <td>{prop.value}</td>
                                      <td>{prop.order}</td>
                                    </tr>
                                  ))
                                )
                              ) : (
                                <tr>
                                  <td colSpan="100%" className="text-center">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  )}

                  {invoiceViewList?.associated_documents?.length > 0 && (
                    <div className="row">
                      <h4>{t("associated_documents")}</h4>

                      <div className="col-lg-12">
                        <div className="vehicleThBg table-responsive table-responsive-sm">
                          <Table
                            className="rounded-table"
                            striped
                            bordered
                            hover
                          >
                            <thead>
                              <tr>
                                <th>{t("name")}</th>
                                <th>{t("value")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoiceViewList?.maloni_data
                                ?.associated_documents?.length > 0 ? (
                                invoiceViewList?.maloni_data?.associated_documents.map(
                                  (item, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <tr>
                                          <td>
                                            {
                                              item.associated_document
                                                ?.entity_name
                                            }
                                          </td>
                                          <td>
                                            {
                                              item.associated_document
                                                ?.entity_number
                                            }
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    );
                                  }
                                )
                              ) : (
                                <tr>
                                  <td colSpan="100%" className="text-center">
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  )}
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleViewInvoiceClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default MoloniInvoiceReceipts;
